import PropTypes from "prop-types"
import styled from "styled-components"
import {
  internalButtonTextTheme,
  borderTheme,
  internalButtonBackgroundTheme,
} from "../../theme"
import { fontBold, fontSemiBold } from "../../utils/fontFamily"
import { hover } from "../../utils/transitions"
import { buttonShadow } from "../../utils/shadows"

const ExternalButton = styled.a`
  display: block;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "20px")};
  text-decoration: none;
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "275px")};
  color: ${({ color }) => (color ? "#fff" : internalButtonTextTheme)};
  background-color: ${({ color }) =>
    color ? color : internalButtonBackgroundTheme};
  text-decoration: none;
  border: ${({ color }) => (color ? `none` : `1px solid ${borderTheme}`)};
  border-color: ${({ color }) => (color ? `none` : borderTheme)};
  border-width: ${({ color }) => (color ? `none` : "1px")};
  border-style: ${({ color }) => (color ? `none` : "solid")};
  
  ${({ outline }) =>
    outline &&
    `
  color: ${outline};
  border-color: ${outline};
  border-width: 2px;
  `};

  border-radius: 10px;
  padding: 15px 60px;
  text-align: center;
  font-size: 15px;
  ${fontSemiBold};
  ${hover()};

  &:hover {
    ${hover()};
    ${buttonShadow()};
    transform: translateY(-2px) scale(1.05);
  }

    ${({ theme }) => theme.se`
    &.custom-call-btn{
      color: #57AC2D;
      border-color: #57AC2D;
      font-size: 20px;
    }

    width: ${({ fullWidth }) => (fullWidth ? "100%" : "210px")};
  `}
    ${({ theme }) => theme.tablet`
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "180px")};
    padding: 8px 5px;
  `}
    ${({ theme }) => theme.desktop`
    padding: 15px;
    font-size: 18px;
 

      &.pricingButton {
     font-size: 20px;
     ${fontSemiBold};
    
   }
   &.featureButton{
     font-size: 18px;
   }
   &.trialButton{
    width: 250px;
    font-size: 20px;
  }
  `}
    ${({ theme }) => theme.largeDesktop`
   &.pricingButton {
     font-size: 22px;
     width: 47%;
   }
  `};
`

ExternalButton.propTypes = {
  href: PropTypes.string,
  children: PropTypes.string,
  color: PropTypes.string,
}

ExternalButton.defaultProps = {
  href: "/",
  children: "Learn More",
  color: null,
}

export default ExternalButton
